import React from "react";
import { useSelector } from "react-redux";
import { IEvent } from "@Interfaces";
import { usePopup, Popup } from "@Modules/common/Popups";
import { ButtonV2 } from "@Modules/common/ButtonV2";
import { DISCOUNT_OFF_TYPES, SELECTORS } from "@Utils";
import { DEFAULT_DIAPLAY_DATE_FORMAT } from "repoV2/features/Common/modules/DateTime/modules/Time/Time.constants";
import { CURRENCY_SYMBOLS } from "repoV2/constants/payment";
import { checkIsStringEmpty } from "repoV2/utils/common/dataTypes/string";
import { parseDateTime } from "@Utils/parseDateTime";
import type { IOfferPopup } from "./IOfferPopup";

import styles from "./OfferPopup.module.scss";

const OfferPopup = ({
    closePopup,
    coupons,
    applyCode,
    discountCode,
    currency,
}: IOfferPopup.IProps) => {
    const { discountError }: IEvent.IDiscount = useSelector(
        SELECTORS.discountInfo
    );
    const { closePopupWithAnimation, closing, animationDuration } = usePopup({
        closePopup,
    });

    const handleApply = (codeProp: string) => {
        if (discountCode === codeProp && checkIsStringEmpty(discountError))
            return;
        applyCode(codeProp);
    };

    return (
        <Popup
            closePopup={closePopupWithAnimation}
            containerClass={styles.popupContainer}
            closing={closing}
            animationDuration={animationDuration}
            classNames={{
                root: styles.popupRoot,
            }}
        >
            <div className={styles.header}>
                <div className={styles.title}>Available Coupon Codes</div>
                <div className={styles.close} onClick={closePopupWithAnimation}>
                    &times;
                </div>
            </div>
            <div className={styles.body}>
                {coupons
                    .filter(
                        coupon =>
                            coupon.currency === currency ||
                            coupon.type === DISCOUNT_OFF_TYPES.PERCENTAGE
                    )
                    .map(item => {
                        const codeApplied =
                            discountCode === item.code &&
                            checkIsStringEmpty(discountError);
                        return (
                            <div key={item.uuid} className={styles.card}>
                                <div className={styles.ctaRow}>
                                    <div className={styles.discountCode}>
                                        {item.code}
                                    </div>
                                    <ButtonV2
                                        className={styles.applyCta}
                                        disabled={codeApplied}
                                        onClick={() => handleApply(item.code)}
                                    >
                                        {codeApplied ? "Applied" : "Apply"}
                                    </ButtonV2>
                                </div>
                                <div className={styles.text}>
                                    {item.promotional_data?.description ? (
                                        item.promotional_data?.description
                                    ) : (
                                        <>
                                            Use this coupon to get flat&nbsp;
                                            <strong>
                                                {item.type ===
                                                DISCOUNT_OFF_TYPES.ABSOLUTE
                                                    ? `${
                                                          CURRENCY_SYMBOLS[
                                                              (item?.currency in
                                                              CURRENCY_SYMBOLS
                                                                  ? item?.currency
                                                                  : "INR") as keyof typeof CURRENCY_SYMBOLS
                                                          ]
                                                      }${item.value}`
                                                    : `${item.value}%`}
                                            </strong>
                                            &nbsp;discount on the booking.
                                        </>
                                    )}
                                    <br />
                                    <strong>
                                        Valid till&nbsp;
                                        {parseDateTime(
                                            item.expiry,
                                            DEFAULT_DIAPLAY_DATE_FORMAT
                                        )}
                                    </strong>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </Popup>
    );
};

export default OfferPopup;
